import { createContext } from 'react';
import type { QuotaRead } from '../../types/api';

export interface QuotaContextValue {
  /**
   * The current month's allowance, or null while it loads and whenever the
   * lookup failed. Null is never treated as "no runs left": the counter shows
   * `--/--` and nothing is blocked client-side. The backend is the only thing
   * that enforces the quota, and it does so with a 429.
   */
  quota: QuotaRead | null;
  /** True while the first read for this business is in flight. */
  isLoading: boolean;
  /** Re-reads the quota. Called after anything that spends one. */
  refresh: () => void;
}

/**
 * The remaining-generations context, mounted in `AppLayout` above both the
 * header counter and the routed screen, so a generation submitted on one screen
 * updates the number displayed on another without a reload.
 *
 * It lives in `src/components/` rather than a feature folder because the counter
 * is chrome — permanently visible on every screen (SRS §2) — and because both
 * `generation` and `review` spend against it.
 */
export const QuotaContext = createContext<QuotaContextValue | null>(null);
